import { RenderCellProps, RenderCheckboxProps, RenderGroupCellProps, RenderHeaderCellProps, RenderSummaryCellProps, useRowSelection } from "react-data-grid"
import { EquipmentReportTableData, PointTableData, PersonReportTableData, IteractionViewData, DataRow } from "../../stores/TabsStore";

export function SummaryRows<R,SR>(props: RenderSummaryCellProps<R,SR>) {
  const {column, row} = props
  let values = (row as any)[column.key]
  return values ? <span className="font-medium">{values}</span> : <></>
}


// REPORT HIDDEN RENDERS

export function HiddenRenderer(props: RenderHeaderCellProps<DataRow>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return ( 
    <SelectCellFormatter
      aria-label="Select All"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked) => {
        onRowSelectionChange({ type: 'HEADER', checked });
      }}
    />
  );
}

export function HiddenFormatter(props: RenderCellProps<DataRow>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return (
    <SelectCellFormatter
      aria-label="Select"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked, isShiftClick) => {
        onRowSelectionChange({ type: 'ROW', row: props.row, checked, isShiftClick });
      }}
    />
  );
}

export function HiddenGroupFormatter(props: RenderGroupCellProps<DataRow>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return ( 
    <SelectCellFormatter
      aria-label="Select Group"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked) => {
        onRowSelectionChange({ type: 'ROW', row: props.row, checked, isShiftClick: false });
      }}
    />
  );
}

// EQUIPMENT HIDDEN RENDERS

export function EquipmentHiddenRenderer(props: RenderHeaderCellProps<EquipmentReportTableData>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return ( 
    <SelectCellFormatter
      aria-label="Select All"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked) => {
        onRowSelectionChange({ type: 'HEADER', checked });
      }}
    />
  );
}

export function EquipmentHiddenFormatter(props: RenderCellProps<EquipmentReportTableData>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return (
    <SelectCellFormatter
      aria-label="Select"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked, isShiftClick) => {
        onRowSelectionChange({ type: 'ROW', row: props.row, checked, isShiftClick });
      }}
    />
  );
}

export function EquipmentHiddenGroupFormatter(props: RenderGroupCellProps<EquipmentReportTableData>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return ( 
    <SelectCellFormatter
      aria-label="Select Group"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked) => {
        onRowSelectionChange({ type: 'ROW', row: props.row, checked, isShiftClick: false });
      }}
    />
  );
}




// IDLE HIDDEN RENDERS

export function IdleHiddenRenderer(props: RenderHeaderCellProps<PointTableData>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return ( 
    <SelectCellFormatter
      aria-label="Select All"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked) => {
        onRowSelectionChange({ type: 'HEADER', checked });
      }}
    />
  );
}

export function IdleHiddenFormatter(props: RenderCellProps<PointTableData>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return (
    <SelectCellFormatter
      aria-label="Select"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked, isShiftClick) => {
        onRowSelectionChange({ type: 'ROW', row: props.row, checked, isShiftClick });
      }}
    />
  );
}

export function IdleHiddenGroupFormatter(props: RenderGroupCellProps<PointTableData>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return ( 
    <SelectCellFormatter
      aria-label="Select Group"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked) => {
        onRowSelectionChange({ type: 'ROW', row: props.row, checked, isShiftClick: false });
      }}
    />
  );
}

// ITERACTION HIDDEN RENDERS

export function IteractionHiddenRenderer(props: RenderHeaderCellProps<IteractionViewData>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return ( 
    <SelectCellFormatter
      aria-label="Select All"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked) => {
        onRowSelectionChange({ type: 'HEADER', checked });
      }}
    />
  );
}

export function IteractionHiddenFormatter(props: RenderCellProps<IteractionViewData>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return (
    <SelectCellFormatter
      aria-label="Select"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked, isShiftClick) => {
        onRowSelectionChange({ type: 'ROW', row: props.row, checked, isShiftClick });
      }}
    />
  );
}

export function IteractionHiddenGroupFormatter(props: RenderGroupCellProps<IteractionViewData>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return ( 
    <SelectCellFormatter
      aria-label="Select Group"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked) => {
        onRowSelectionChange({ type: 'ROW', row: props.row, checked, isShiftClick: false });
      }}
    />
  );
}


// PERSON HIDDEN RENDERS

export function PersonHiddenRenderer(props: RenderHeaderCellProps<PersonReportTableData>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return ( 
    <SelectCellFormatter
      aria-label="Select All"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked) => {
        onRowSelectionChange({ type: 'HEADER', checked });
      }}
    />
  );
}

export function PersonHiddenFormatter(props: RenderCellProps<PersonReportTableData>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return (
    <SelectCellFormatter
      aria-label="Select"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked, isShiftClick) => {
        onRowSelectionChange({ type: 'ROW', row: props.row, checked, isShiftClick });
      }}
    />
  );
}

export function PersonHiddenGroupFormatter(props: RenderGroupCellProps<PersonReportTableData>) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();

  return ( 
    <SelectCellFormatter
      aria-label="Select Group"
      tabIndex={props.tabIndex}
      value={isRowSelected}
      onChange={(checked) => {
        onRowSelectionChange({ type: 'ROW', row: props.row, checked, isShiftClick: false });
      }}
    />
  );
}


type SharedInputProps = Pick<
  RenderCheckboxProps,
  'disabled' | 'tabIndex' | 'aria-label' | 'aria-labelledby'
>;

interface SelectCellFormatterProps extends SharedInputProps {
  value: boolean;
  onChange: (value: boolean, isShiftClick: boolean) => void;
}

export function SelectCellFormatter({
  value,
  tabIndex,
  disabled,
  onChange,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy
}: SelectCellFormatterProps) {

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    onChange(e.target.checked, (e.nativeEvent as MouseEvent).shiftKey);
  }

  return (
    <div className="flex items-center h-full">
      <input type="checkbox" aria-label={ariaLabel} aria-labelledby={ariaLabelledBy} checked={value} tabIndex={tabIndex} onChange={(e) => handleChange(e)}/>
    </div>
  );
}